import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { Button, useMediaQuery } from '@americanexpress/dls-react';
import { getOneCmsLoungeFinderImagesBaseUrl } from '@/selectors/oneCmsSelectors';
import { getLoginUrl } from '@/selectors/configSelectors';
import { useCommonContent } from '@/hooks/oneCmsIntlHooks/oneCmsIntlHelperHooks';
import { useRouteParams } from '@/context/routeParamsContext';
import { useAnalyticsContext } from '@/context/analyticsContext';
import { pageSessionKey, loginPageValue } from '@/constants';
import DividerWithMessage from './DividerWithMessage';

const LoginCard = ({ label, showDivider }) => {
  const baseOneCmsImgUrl = useSelector(getOneCmsLoungeFinderImagesBaseUrl);
  const loginOrigin = useSelector(getLoginUrl);
  const { locale } = useRouteParams();
  const { login, selectCard } = useCommonContent();
  const { customTrack } = useAnalyticsContext();
  const isLargeWidth = useMediaQuery('(min-width: 568px)');

  const handleClick = (e) => {
    customTrack({
      event: e,
      element: 'log-in-button',
    });
    const returnUrl = window.location.href;
    window.sessionStorage.setItem(pageSessionKey, loginPageValue);
    const fullUrl = `${loginOrigin}/${locale}/account/login?DestPage=${encodeURIComponent(returnUrl)}`;
    window.location.assign(fullUrl);
  };

  return (
    <>
      <div
        className="tw-border-blue-deep-tint-t12 tw-mb-6 tw-rounded-lg tw-bg-blue-deep-700 tw-bg-contain tw-bg-no-repeat tw-p-6 sm_tw-flex sm_tw-items-center sm_tw-gap-4"
        style={{
          backgroundImage: `url(${baseOneCmsImgUrl}${isLargeWidth ? 'amex-logo-accent' : 'amex-logo-accent-mobile'}.png)`,
        }}
      >
        <div className="sm_tw-mb-0 sm_tw-flex sm_tw-flex-col">
          <p className="tw-heading-xs-bold tw-text-gray-100">{login?.header}</p>
          <p className="tw-text-gray-200">{label}</p>
        </div>
        <Button
          variant="primary"
          className="tw-ml-auto tw-mt-4 tw-max-h-fit tw-w-full tw-min-w-fit tw-max-w-none sm_tw-mt-0 sm_tw-w-auto"
          onClick={handleClick}
          reactlytics={{ disable: true }}
        >
          {login?.button}
        </Button>
      </div>
      {showDivider && <DividerWithMessage message={selectCard?.divider} />}
    </>
  );
};

LoginCard.propTypes = {
  label: PropTypes.string.isRequired,
  showDivider: PropTypes.bool,
};

LoginCard.defaultProps = {
  showDivider: false,
};

export default LoginCard;
